import { saveAs } from 'file-saver';
import moment from 'moment';
import { serialize } from 'object-to-formdata';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { pdf } from '@react-pdf/renderer';
import { Botao } from '../../../components/Botao';
import { CartaoDeInformacao } from '../../../components/CartaoDeInformacao';
import { CorpoDaPagina } from '../../../components/CorpoDaPagina';
import { EnvioArquivo } from '../../../components/EnvioArquivo';
import { Input } from '../../../components/Input';
import { Modal } from '../../../components/Modal';
import { ProtocoloSolicitacaoPdf } from '../../../components/ProtocoloSolicitacaoPdf';
import { Radio } from '../../../components/Radio';
import { Seletor } from '../../../components/Seletor';
import TextArea from '../../../components/TextArea';
import { InstituicaoStore } from '../../../stores/InstituicaoStore';
import { MunicipioStore } from '../../../stores/MunicipioStore';
import { SolicitacaoStore } from '../../../stores/SolicitacaoStore';
import { AcoesConteiner, CampoConteiner, Formulario, Divisor, CamposConteiner } from './styles';

function SolicitacaoFormulario() {
  const [documentoDeTutela, atribuirDocumentoDeTutela] = useState(false);
  const [fotoAluno, atribuirFotoAluno] = useState(false);
  const [fotoAlunoComDocumento, atribuirFotoAlunoComDocumento] = useState(false);
  const [fotoResponsavelComDocumento, atribuirFotoResponsavelComDocumento] = useState(false);
  const [grauEscolaridade, atribuirGrauEscolaridade] = useState([]);
  const [idade, atribuirIdade] = useState(0);
  const [instituicoes, atribuirInstituicoes] = useState([]);
  const [municipios, atribuirMunicipios] = useState([]);
  const [opcoesModal, atribuirOpcoesModal] = useState({ open: false });
  const [opcoesModalAprovar, atribuirOpcoesModalAprovar] = useState({ open: false });
  const [pcd, atribuirPcd] = useState(null);
  const [responsavel, atribuirResponsavel] = useState(null);
  const [solicitacao, atribuirSolicitacao] = useState(null);

  let historico = useHistory();

  const { pathname } = useLocation();
  const [editar] = useState(pathname.toUpperCase().includes('EDITAR'));
  const [visualizar] = useState(pathname.toUpperCase().includes('VISUALIZAR'));

  let { protocolo } = useParams();

  const formRef = useRef(null);

  const aprovar = useCallback(async () => {
    if (!visualizar) {
      formRef.current.submitForm();
      return;
    }
    await SolicitacaoStore.aprovar(protocolo).then((response) => {
      if (response.status === 200) {
        toast.success(response.data.mensagem);
        historico.push('/solicitacoes');
      } else {
        toast.error(response.data.mensagem);
      }
    });
  }, [protocolo, historico, visualizar]);

  const getInstituicoes = useCallback(
    async (municipio) => {
      const call = async () => {
        await InstituicaoStore.obterFiltradaPaginada({
          ativo: true,
          municipio,
          RegistroPorPagina: 9999,
        }).then((response) => {
          if (response.status === 200) {
            atribuirInstituicoes([
              { label: 'Selecione', value: '' },
              ...response.data.lista.map((item) => ({
                label: item.nome,
                value: item.id,
              })),
            ]);
          } else if (response.status === 204) {
            toast.error('Não há instituições de ensino cadastradas');
          } else toast.error(response.data.mensagem);
        });
      };

      call();
    },
    [pathname],
  );

  const atribuirDataNascimento = (value) => {
    atribuirIdade(moment().diff(value, 'years', false));
  };

  const controlarModal = () => {
    atribuirOpcoesModal({ open: false });
  };

  const botoesModalReprovar = (
    <>
      <Botao
        texto='Cancelar'
        aoClicar={() => atribuirOpcoesModal({ open: false })}
        cor='background'
      />
      <Botao texto='Reprovar' aoClicar={() => reprovar()} cor='danger' />,
    </>
  );

  const botoesModalAprovar = (
    <>
      <Botao
        texto='Cancelar'
        aoClicar={() => atribuirOpcoesModalAprovar({ open: false })}
        cor='background'
      />
      <Botao texto='Aprovar' aoClicar={() => aprovar()} cor='success' />
    </>
  );

  const corStatus = (status) => {
    switch (status) {
      case 'APROVADO':
        return 'sucesso';
      case 'REPROVADO':
        return 'erro';
      case 'EM ANÁLISE':
        return 'info';
      default:
        return 'info';
    }
  };

  const enviarFormulario = useCallback(
    async (data) => {
      formRef.current?.setErrors({});
      let error = false;

      if (data.nomeCompleto === '') {
        formRef.current?.setFieldError('nomeCompleto', 'Campo obrigatório');
        error = true;
      }
      if (data.dataDeNascimento === '') {
        formRef.current?.setFieldError('dataDeNascimento', 'Campo obrigatório');
        error = true;
      }
      if (data.identificacaoDocumento === '') {
        formRef.current?.setFieldError('identificacaoDocumento', 'Campo obrigatório');
        error = true;
      }
      if (data.fotoAluno === '' || !data.fotoAluno) {
        if (!editar || (editar && fotoAluno === false)) {
          formRef.current?.setFieldError('fotoAluno', 'Campo obrigatório');
          error = true;
        }
      }
      if (data.email === '') {
        formRef.current?.setFieldError('email', 'Campo obrigatório');
        error = true;
      }
      if (data.pessoaComDeficiencia === '' || !data.pessoaComDeficiencia) {
        formRef.current?.setFieldError('pessoaComDeficiencia', 'Campo obrigatório');
        error = true;
      }

      if (
        data.pessoaComDeficiencia === 'true' &&
        (data.possuiResponsavel === '' || !data.possuiResponsavel)
      ) {
        formRef.current?.setFieldError('possuiResponsavel', 'Campo obrigatório');
        error = true;
      }
      if (data.municipio === '') {
        formRef.current?.setFieldError('municipio', 'Campo obrigatório');
        error = true;
      }
      if (data.instituicaoDeEnsinoId === '') {
        formRef.current?.setFieldError('instituicaoDeEnsinoId', 'Campo obrigatório');
        error = true;
      }
      if (data.grauEscolaridade === '') {
        formRef.current?.setFieldError('grauEscolaridade', 'Campo obrigatório');
        error = true;
      }
      if (data.codigoRegistroMatricula === '') {
        formRef.current?.setFieldError('codigoRegistroMatricula', 'Campo obrigatório');
        error = true;
      }
      if (
        (data.pessoaComDeficiencia === 'true' && data.possuiResponsavel === 'true') ||
        (idade < 18 && idade >= 0)
      ) {
        if (data.nomeResponsavel === '') {
          formRef.current?.setFieldError('nomeResponsavel', 'Campo obrigatório');
          error = true;
        }
        if (data.identificacaoDocumentoResponsavel === '') {
          formRef.current?.setFieldError('identificacaoDocumentoResponsavel', 'Campo obrigatório');
          error = true;
        }
        if (data.documentoDeTutela === '' || !data.documentoDeTutela) {
          if (!editar || (editar && documentoDeTutela === false)) {
            formRef.current?.setFieldError('documentoDeTutela', 'Campo obrigatório');
            error = true;
          }
        }
        if (data.fotoResponsavelComDocumento === '' || !data.fotoResponsavelComDocumento) {
          if (!editar || (editar && fotoResponsavelComDocumento === false)) {
            formRef.current?.setFieldError('fotoResponsavelComDocumento', 'Campo obrigatório');
            error = true;
          }
        }
      } else {
        if (data.fotoAlunoComDocumento === '' || !data.fotoAlunoComDocumento) {
          if (!editar || (editar && fotoAlunoComDocumento === false)) {
            formRef.current?.setFieldError('fotoAlunoComDocumento', 'Campo obrigatório');
            error = true;
          }
        }
      }

      if (error) {
        return;
      }

      const form = serialize(data);

      if (editar) {
        await SolicitacaoStore.editar(protocolo, form).then((response) => {
          if (response.status === 200) {
            toast.success(response.data.mensagem);
            historico.push('/solicitacoes');
          } else {
            toast.error(response.data.mensagem);
          }
        });
      } else {
        await SolicitacaoStore.criar(form).then(async (response) => {
          if (response.status === 201) {
            toast.success(response.data.mensagem);
            const doc = <ProtocoloSolicitacaoPdf protocolo={response.data.protocolo} />;
            const asPdf = pdf([]);
            asPdf.updateContainer(doc);
            const blob = await asPdf.toBlob();
            saveAs(blob, `${response.data.protocolo}.pdf`);
            historico.push('/solicitacoes');
          } else {
            toast.error(response.data.mensagem);
          }
        });
      }
    },
    [
      idade,
      documentoDeTutela,
      editar,
      fotoAluno,
      fotoAlunoComDocumento,
      fotoResponsavelComDocumento,
      historico,
      protocolo,
    ],
  );

  const mudarInstituicao = (value) => {
    obterGrauDeEscolaridade(value);
  };

  const mudarMunicipio = async (value) => {
    await getInstituicoes(value);
    await atribuirSolicitacao({ ...solicitacao, grauEscolaridade: '' });
    await atribuirGrauEscolaridade([]);
    await formRef.current.setFieldValue('grauEscolaridade', '');
  };

  const obterGrauDeEscolaridade = useCallback(async (id) => {
    await InstituicaoStore.obterModalidadesPorInstuticao(id).then((response) => {
      if (response.status === 200) {
        atribuirGrauEscolaridade([
          { label: 'Selecione', value: '' },
          ...response.data.map((item) => ({
            label: item.nome,
            value: item.nome,
          })),
        ]);
      } else if (response.status === 204) {
        toast.error('Não há modalidade para a instituição informada');
      } else toast.error(response.data.mensagem);
    });
  }, []);

  const reprovar = useCallback(async () => {
    formRef.current?.setErrors({});
    const motivo = formRef.current.getFieldValue('motivo');
    if (motivo === '') {
      formRef.current?.setFieldError('motivo', 'Campo obrigatório');
      return;
    }

    const form = serialize({ motivo: motivo });

    await SolicitacaoStore.reprovar(protocolo, form).then((response) => {
      if (response.status === 200) {
        toast.success(response.data.mensagem);
        historico.push('/solicitacoes');
      } else {
        toast.error(response.data.mensagem);
      }
    });
  }, [formRef, protocolo, historico]);

  useEffect(() => {
    const callView = async () => {
      await MunicipioStore.obterMunicipios().then((response) => {
        if (response.status === 200) {
          atribuirMunicipios([
            { label: 'Selecione', value: '' },
            ...response.data.map((item) => ({
              label: item.nome,
              value: item.nome,
            })),
          ]);
        } else if (response.status === 204) {
          toast.error('Não há municípios cadastrados');
        } else toast.error(response.data.mensagem);
      });
    };

    callView();
  }, []);

  useEffect(() => {
    const callView = async () => {
      if (
        municipios.length > 0 &&
        (pathname.toUpperCase().includes('VISUALIZAR') || pathname.toUpperCase().includes('EDITAR'))
      ) {
        await SolicitacaoStore.obterPorProtocolo(protocolo).then((response) => {
          if (response.status === 200) {
            atribuirSolicitacao({
              ...response.data,
              dataDeNascimento: response.data.dataDeNascimento.split('T')[0],
            });
          } else {
            toast.error(response.data.mensagem);
          }
        });
      }
    };

    callView();
  }, [municipios, pathname, protocolo]);

  return (
    <CorpoDaPagina
      voltar
      titulo={`${visualizar || editar ? 'Solicitação ' + protocolo : 'Nova Solicitação'}`}
    >
      <Formulario
        ref={formRef}
        onSubmit={enviarFormulario}
        initialData={
          visualizar || editar
            ? solicitacao
            : {
                dataDeNascimento: moment().subtract(18, 'years').format('yyyy-MM-DD'),
              }
        }
      >
        {solicitacao?.status && (
          <CartaoDeInformacao texto={solicitacao.status} tipo={corStatus(solicitacao.status)} />
        )}
        <CampoConteiner>
          <Input
            nome='nomeCompleto'
            titulo='Nome completo do aluno'
            desabilitado={visualizar}
            placeholder={'Informe o nome completo do aluno'}
          />
          <Input
            nome='nomeSocial'
            titulo='Nome social do aluno'
            desabilitado={visualizar}
            placeholder={'Informe o nome social do aluno'}
          />
        </CampoConteiner>

        <CampoConteiner>
          <Input
            nome='dataDeNascimento'
            titulo='Data de nascimento'
            tipo='date'
            aoAtribuirValor={atribuirDataNascimento}
            desabilitado={visualizar}
            valorMaximo={moment().format('yyyy-MM-DD')}
          />
          <Input
            nome='cpf'
            titulo='CPF'
            desabilitado={visualizar}
            mascara
            placeholder={'Informe o CPF'}
          />
          <Input
            nome='identificacaoDocumento'
            titulo='Número do documento de identidade'
            placeholder='RG, CNH, RNE, RCN ou passaporte'
            desabilitado={visualizar}
          />
        </CampoConteiner>

        <CampoConteiner>
          <Input
            nome='email'
            titulo='E-mail'
            desabilitado={visualizar}
            placeholder={'Informe o e-mail'}
          />
          <Radio
            nome='pessoaComDeficiencia'
            titulo='Pessoa com deficiência'
            aoAtribuirValor={atribuirPcd}
            opcoes={[
              { label: 'SIM', value: true },
              { label: 'NÃO', value: false },
            ]}
            desabilitado={visualizar}
          />
          {pcd && idade >= 18 && (
            <Radio
              nome='possuiResponsavel'
              titulo='Possui responsável?'
              aoAtribuirValor={atribuirResponsavel}
              opcoes={[
                { label: 'SIM', value: true },
                { label: 'NÃO', value: false },
              ]}
              desabilitado={!pcd || visualizar}
            />
          )}
        </CampoConteiner>

        <CampoConteiner>
          <EnvioArquivo
            nome='fotoAluno'
            titulo='Foto do aluno'
            placeholder=''
            desabilitado={visualizar}
            existeArquivo={() => atribuirFotoAluno(true)}
          />
          {!((pcd === true && responsavel === true) || (idade < 18 && idade >= 0)) && (
            <EnvioArquivo
              nome='fotoAlunoComDocumento'
              titulo='Foto do documento'
              placeholder=''
              desabilitado={visualizar}
              existeArquivo={() => atribuirFotoAlunoComDocumento(true)}
            />
          )}
        </CampoConteiner>

        <Divisor />
        <h4>Dados da instituição de ensino</h4>
        <CamposConteiner>
          <CampoConteiner>
            <Seletor
              nome='municipio'
              titulo='Município'
              opcoes={municipios}
              aoAtribuirValor={mudarMunicipio}
              desabilitado={visualizar}
            />
            <Seletor
              nome='instituicaoDeEnsinoId'
              titulo='Instituição de ensino'
              opcoes={instituicoes}
              aoAtribuirValor={mudarInstituicao}
              desabilitado={visualizar || instituicoes.length === 0}
            />
          </CampoConteiner>

          <CampoConteiner>
            <Seletor
              nome='grauEscolaridade'
              titulo='Etapa ou modalidade de ensino'
              opcoes={grauEscolaridade}
              desabilitado={visualizar || grauEscolaridade.length === 0}
            />
            <Input
              nome='codigoRegistroMatricula'
              titulo='Código do aluno ou matrícula'
              placeholder='Informe o código do aluno ou matrícula'
              desabilitado={visualizar}
            />
          </CampoConteiner>
        </CamposConteiner>

        {((pcd === true && responsavel === true) || (idade < 18 && idade >= 0)) && (
          <>
            <Divisor />
            <h4>Dados do responsável</h4>
            <CamposConteiner>
              <CampoConteiner>
                <Input nome='nomeResponsavel' titulo='Nome completo' desabilitado={visualizar} />

                <Input
                  nome='identificacaoDocumentoResponsavel'
                  titulo='Número do documento de identidade'
                  placeholder='RG, CNH, RNE, RCN ou passaporte'
                  desabilitado={visualizar}
                />
              </CampoConteiner>

              <CampoConteiner>
                <EnvioArquivo
                  nome='fotoResponsavelComDocumento'
                  titulo='Foto do responsável'
                  placeholder=''
                  desabilitado={visualizar}
                  existeArquivo={() => atribuirFotoResponsavelComDocumento(true)}
                />

                <EnvioArquivo
                  nome='documentoDeTutela'
                  titulo='Documento de identificação com foto'
                  placeholder=''
                  desabilitado={visualizar}
                  existeArquivo={() => atribuirDocumentoDeTutela(true)}
                />
              </CampoConteiner>
            </CamposConteiner>
          </>
        )}
        {(editar || visualizar) && solicitacao?.observacao && (
          <>
            <CamposConteiner>
              <CampoConteiner $full>
                <TextArea nome='observacao' titulo='Observação' desabilitado={true} />
              </CampoConteiner>
            </CamposConteiner>
          </>
        )}
        <CamposConteiner>
          <AcoesConteiner>
            {visualizar &&
              (solicitacao?.status === 'EM ANÁLISE' || solicitacao?.status === 'APROVADO') && (
                <Botao
                  texto='Reprovar'
                  cor='danger'
                  aoClicar={() => atribuirOpcoesModal({ open: true })}
                />
              )}
            {solicitacao?.status !== 'APROVADO' && (
              <Botao
                texto='Aprovar'
                cor='success'
                aoClicar={() => atribuirOpcoesModalAprovar({ open: true })}
              />
            )}
          </AcoesConteiner>
        </CamposConteiner>
        {opcoesModal.open && (
          <Modal
            titulo='Reprovar solicitação'
            acoes={botoesModalReprovar}
            controleAberturaModal={controlarModal}
          >
            <span>Digite o motivo da reprovação</span>
            <TextArea nome='motivo' />
          </Modal>
        )}
        {opcoesModalAprovar.open && (
          <Modal
            titulo='Aprovar solicitação'
            acoes={botoesModalAprovar}
            controleAberturaModal={controlarModal}
          >
            <span>Deseja aprovar esta solicitação?</span>
          </Modal>
        )}
      </Formulario>
    </CorpoDaPagina>
  );
}

export default SolicitacaoFormulario;
